/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Trainer_BodyInputs */

const en_for_whom_trainer_body = /** @type {(inputs: For_Whom_Trainer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A training plan for your goal, your technique watched, and progress set by set.`)
};

const pl_for_whom_trainer_body = /** @type {(inputs: For_Whom_Trainer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan treningowy pod Twój cel, technika pod okiem i progres seria po serii.`)
};

/**
* | output |
* | --- |
* | "A training plan for your goal, your technique watched, and progress set by set." |
*
* @param {For_Whom_Trainer_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_trainer_body = /** @type {((inputs?: For_Whom_Trainer_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Trainer_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_trainer_body(inputs)
	return en_for_whom_trainer_body(inputs)
});